"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.I18nConnection = void 0;
const json_rpc_1 = require("@hediet/json-rpc");
const json_rpc_websocket_1 = require("@hediet/json-rpc-websocket");
const disposable_1 = require("@hediet/std/disposable");
const timer_1 = require("@hediet/std/timer");
const loginContract_1 = require("./loginContract");
const mainContract_1 = require("./mainContract");
const siteAdminContract_1 = require("./siteAdminContract");
const versionContract_1 = require("./versionContract");
class I18nConnection {
    serverUrl;
    channel;
    stream;
    static async connectTo(serverUrl) {
        console.log("connecting to ", serverUrl);
        // Remove trailing /
        if (serverUrl.endsWith("/")) {
            serverUrl = serverUrl.substr(0, serverUrl.length - 1);
        }
        const wsUrl = serverUrl.replace(/^http/, "ws");
        const stream = await json_rpc_websocket_1.WebSocketStream.connectTo({
            address: wsUrl,
        });
        const channel = json_rpc_1.TypedChannel.fromStream(stream, {
            logger: process.env["NODE_ENV"] === "development"
                ? new json_rpc_1.ConsoleRpcLogger()
                : undefined,
            ignoreUnexpectedPropertiesInResponses: process.env["NODE_ENV"] !== "development",
        });
        channel.startListen();
        return new I18nConnection(serverUrl, channel, stream);
    }
    authApi;
    siteAdminApi;
    mainApi;
    versionApi;
    getTranslationsJsonUrl(orgId, projectId, versionId, lang) {
        return `${this.serverUrl}/orgs/${orgId}/projects/${projectId}/versions/${versionId}/translations/${lang}`;
    }
    dispose = disposable_1.Disposable.fn();
    // We need this for proxies.
    // Proxies tend to disconnect websocket connections after some time without communication.
    stayAliveTimer = this.dispose.track(new timer_1.EventTimer(10 * 1000, "started"));
    constructor(serverUrl, channel, stream) {
        this.serverUrl = serverUrl;
        this.channel = channel;
        this.stream = stream;
        this.authApi = loginContract_1.authContract.getServer(this.channel, {}).server;
        this.mainApi = mainContract_1.mainContract.getServer(this.channel, {}).server;
        this.versionApi = versionContract_1.versionContract.getServer(this.channel, {}).server;
        this.siteAdminApi = siteAdminContract_1.siteAdminContract.getServer(this.channel, {}).server;
        this.dispose.track(stream);
        this.stayAliveTimer.onTick.sub(() => {
            void this.mainApi.ping();
        });
        void stream.onClosed.then(() => {
            this.dispose();
        });
    }
}
exports.I18nConnection = I18nConnection;
//# sourceMappingURL=I18nConnection.js.map